export * from "ce/sagas/moduleInstanceSagaUtils";
import { startExecutingJSFunction } from "actions/jsPaneActions";
import type { ParamsForJSModuleInstance } from "ce/sagas/moduleInstanceSagaUtils";
import { MODULE_TYPE } from "ee/constants/ModuleConstants";
import type {
  JSModuleInstanceEntityConfig,
  ModuleInstanceEntity,
} from "ee/entities/DataTree/types";
import { getModuleInstancePublicEntity } from "ee/selectors/moduleInstanceSelectors";
import { isJSModuleInstance } from "ee/workers/Evaluation/evaluationUtils";
import type { JSCollection } from "entities/JSCollection";
import { ActionRunBehaviour } from "PluginActionEditor/types/PluginActionTypes";
import { put, select } from "redux-saga/effects";

export function* executionForJSModuleInstance({
  configTree,
  dataTree,
  entity,
  entityName,
  propertyPath,
}: ParamsForJSModuleInstance) {
  if (isJSModuleInstance(entity)) {
    const moduleEntity = dataTree[entityName] as ModuleInstanceEntity;
    const publicJSCollection: JSCollection = yield select(
      getModuleInstancePublicEntity,
      moduleEntity.moduleInstanceId,
      MODULE_TYPE.JS,
    );

    const action = publicJSCollection.actions.find(
      (action) => action.name === propertyPath,
    );

    if (!action) return;

    const entityConfig = configTree[entityName] as JSModuleInstanceEntityConfig;

    const runBehaviour =
      entityConfig?.meta && entityConfig.meta[action.name]?.runBehaviour;

    if (runBehaviour === ActionRunBehaviour.AUTOMATIC) {
      yield put(
        startExecutingJSFunction({
          action,
          collection: publicJSCollection,
          from: "KEYBOARD_SHORTCUT",
          openDebugger: true,
        }),
      );
    }
  }
}
